import styled from 'styled-components';

export const InformationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid ${({ theme }) => theme.black.a1};
  height: 100%;
  width: 100%;
  padding: 5px 15px;
`;

export const OutsideWrapper = styled.div<{ $clickable: boolean }>`
  display: flex;
  align-items: center;
  height: 56px;
  font-weight: 600;
  font-size: 12px;
  width: 345px;
  &:first-child {
    ${InformationContainer} {
      border-top: ${({ theme, $clickable }) => ($clickable ? `1px solid ${theme.black.a1}` : 'none')};
    }
  }
  &:last-child {
    ${InformationContainer} {
      border-bottom: 1px solid ${({ theme }) => theme.black.a1};
    }

    height: 57px;
  }
  &:hover {
    color: ${({ $clickable, theme }) => ($clickable ? theme.baseBlue.a10 : 'inherit')};
    cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'auto')};
    background-color: ${({ theme, $clickable }) => ($clickable ? theme.black.a0 : 'inherit')};
  }
`;

export const AvatarContainer = styled.div`
  margin: 10px 15px;
`;

export const Amount = styled.div`
  display: flex;
  > span {
    margin-left: 5px;
  }
`;

export const Name = styled.span`
  color: ${({ theme }) => theme.baseBlue.a6};
  &:hover {
    color: ${({ theme }) => theme.baseBlue.a10};
  }
`;

export const Company = styled.span`
  color: ${({ theme }) => theme.brandBlue.dark};
  &:hover {
    color: ${({ theme }) => theme.baseBlue.a10};
  }
`;

export const LeftCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  > div {
    margin-top: 5px;
  }
`;
export const RightCol = styled.div``;
